export const allRoutes = [
  { to: "/MarketWatch", icon: "FaChartPie", label: "Market Watch" },
  {
    label: "Trades",
    to: "/trades",
    icon: "CgFileDocument",
  },
  {
    label: "Ai Trade Analysis",
    to: "/ai-trades",
    icon: "IoMdAnalytics",
  },
  {
    label: "Orders",
    to: "/orders",
    icon: "FaListOl",
  },
  {
    label: "Position",
    to: "/position",
    icon: "FaListCheck",
  },
  {
    label: "Scriptwise Position History",
    to: "/scriptWisePositionHistory",
    icon: "IoMdPaper",
  },
  {
    label: "Userwise Position History",
    to: "/userWisePositionHistory",
    icon: "PiUserListBold",
  },
  {
    label: "Trade Report",
    to: "/tradeReport",
    icon: "FaList",
  },
  {
    label: "Trade Analytics",
    to: "/tradeAnalytics",
    icon: "IoMdAnalytics",
  },
  {
    label: "Scriptwise PL Summary",
    to: "/scriptWisePlSummary",
    icon: "MdMenuBook",
  },
];

export const userReportRoutes = [
  {
    label: "Manage User",
    to: "/user",
    icon: "FaUser",
  },
  {
    label: "AnalyseDevices",
    to: "/analyseDevices",
    icon: "IoMdAnalytics",
  },
  {
    label: "Login History",
    to: "/loginHistory",
    icon: "MdMenuBook",
  },
];

export const MARKET_WATCH_COLUMNS = [
  {
    field: "exchange",
    headerName: "Exchange",
    isActive: true,
    isColor: false,
  },
  {
    field: "name",
    headerName: "Name",
    isActive: true,
    isColor: false,
  },
  {
    field: "expiry",
    headerName: "Expiry",
    isActive: true,
    isColor: false,
  },
  {
    field: "buy_qty_0",
    headerName: "Buy qty",
    isActive: true,
    isColor: false,
  },
  {
    field: "buy_price_0",
    headerName: "Buy Price",
    isActive: true,
    isColor: true,
  },
  {
    field: "sell_price_0",
    headerName: "Sell Price",
    isActive: true,
    isColor: true,
  },
  {
    field: "sell_qty_0",
    headerName: "Sell Qty",
    isActive: true,
    isColor: false,
  },
  {
    field: "last_price",
    headerName: "LTP",
    isActive: true,
    isColor: false,
  },
  {
    field: "net_change",
    headerName: "Net Change",
    isActive: true,
    isColor: true,
  },
  {
    field: "percentage_change",
    headerName: "% change",
    isActive: true,
    isColor: false,
  },
  {
    field: "volume",
    headerName: "Volume",
    isActive: false,
    isColor: false,
  },
  {
    field: "ohlc_open",
    headerName: "Open",
    isActive: true,
    isColor: false,
  },
  {
    field: "ohlc_high",
    headerName: "High",
    isActive: true,
    isColor: false,
  },
  {
    field: "ohlc_low",
    headerName: "Low",
    isActive: true,
    isColor: false,
  },
  {
    field: "ohlc_close",
    headerName: "Close",
    isActive: true,
    isColor: false,
  },
  {
    field: "LastTradeTimeD",
    headerName: "LTT",
    isActive: false,
    isColor: false,
  },
  {
    field: "timestamp",
    headerName: "LUT",
    isActive: true,
    isColor: false,
  },
  {
    field: "lower_circuit",
    headerName: "LC",
    isActive: false,
    isColor: false,
  },
  {
    field: "upper_circuit",
    headerName: "UC",
    isActive: false,
    isColor: false,
  },
  {
    field: "oi",
    headerName: "OI",
    isActive: false,
    isColor: false,
  },
  {
    field: "lot_size",
    headerName: "Lot Size",
    isActive: false,
    isColor: false,
  },
  {
    field: "buy_quantity",
    headerName: "TBQ",
    isActive: false,
    isColor: false,
  },
  {
    field: "sell_quantity",
    headerName: "TSQ",
    isActive: false,
    isColor: false,
  },
  {
    field: "mode",
    headerName: "mode",
    isActive: false,
    isColor: false,
  },
];

export const newScriptObject = ({ scriptToken, name, exchange, expiry }) => {
  return {
    _id: scriptToken,
    ScriptToken: scriptToken,
    exchange,
    tradingsymbol: "",
    expiry,
    ohlc_close: "",
    ohlc_open: "",
    name,
    instrument_token: scriptToken,
    last_price: "",
    ohlc_high: "",
    ohlc_low: "",
    buy_price_0: "",
    sell_price_0: "",
    buy_qty_0: "",
    sell_qty_0: "",
    timestamp: "",
    net_change: "",
    percentage_change: "",
    buy_quantity: "",
    change: "",
    LastTradeTimeD: "",
    oi_day_high: "",
    oi_day_low: "",
    sell_quantity: "",
  };
};
